import {groupSettingsIntoRows} from './aiAssistantSettingsRows';
import AiAssistantSettingTile from './AiAssistantSettingTile';

// A tap confirms that setting; the value it moves to comes from the proposal
const AiAssistantWidgetSettings = ({settings, getSettingValue, onConfirm}) => (
    <div className='pointer-events-auto flex flex-col gap-1'>
        {groupSettingsIntoRows(settings.map(({settingName}) => settingName)).map((row) => (
            <div key={row[0]} className='flex gap-1'>
                {row.map((settingName) => (
                    <AiAssistantSettingTile
                        key={settingName}
                        settingName={settingName}
                        isAlone={row.length === 1}
                        value={getSettingValue(settingName)}
                        onChange={() => onConfirm(settingName)}
                    />
                ))}
            </div>
        ))}
    </div>
);

export default AiAssistantWidgetSettings;
